export const MAIN = 'main';
export const NOTFOUND = 'error_404';
